// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 62 ? "Charpter" : chunkId) + "." + {"62":"5dfbe885","606":"f05486ba","629":"38705ea8"}[chunkId] + ".css";
};